import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyCqv_HMxMLu5-KYYUlRtbmEn2lj1SHD0Kw",
  authDomain: "kora-e9743.firebaseapp.com",
  projectId: "kora-e9743",
  storageBucket: "kora-e9743.firebasestorage.app",
  messagingSenderId: "185150481039",
  appId: "1:185150481039:web:dbb574c6cab7e1ec7246fa",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export { app };
